<div class="inset-0 flex" id="dmt-sub-root">
  <!-- Auth pages -->
  <div class="h-full w-full" *ngIf="!showHeader">
    <router-outlet></router-outlet>
  </div>

  <!-- Main application layout -->
  <div class="flex  h-screen w-full min-w-[768px]" *ngIf="showHeader">
    <!-- Left sidebar navigation -->
    <!--
      Hidden only for CST-style scoped-kiosk sessions (isSSO AND mainLabUrl
      set). Full SSO logins (mainLabUrl null) are regular users authenticated
      via SSO and get the normal sidebar + content offset.
    -->
    <nav *ngIf="!ability.isSSO || !ability.mainLabUrl" class="fixed left-0 top-0 min-w-[100px] h-full bg-white border-r border-gray-200">
      <app-sidebar></app-sidebar>
    </nav>

    <!-- Main content area -->
    <div
      [ngClass]="(ability.isSSO && ability.mainLabUrl)
        ? 'flex flex-col items-center justify-center bg-background-grey min-h-screen w-full h-full overflow-auto'
        : 'ml-[100px] flex flex-col items-center justify-center bg-background-grey min-h-screen w-full h-full overflow-auto'">
      <!-- Top header -->
      <app-header class="flex w-full"></app-header>
      <!-- Main content -->
      <main class="flex-1 overflow-auto w-full px-[20px]  bg-transparent"
        [ngClass]="(ability.isSSO && ability.mainLabUrl) ? 'max-w-[100vw]' : 'max-w-[calc(100vw-100px)]'">
        <div class="wrapper min-w-[1024px] w-full flex items-center justify-center">
          <router-outlet></router-outlet>
        </div>
      </main>
    </div>
  </div>

  <!-- New-version toast and bar, on every page including sign-in -->
  <app-update-prompt></app-update-prompt>
</div>
